export default "__VITE_ASSET__9012691c__"